import Vue from 'vue'

// axios
import axios from 'axios'

import store from '../store'

const actionScope = 'loader'

const axiosIns = axios.create({
    // You can add your headers here
    // ================================
    baseURL: `${process.env.VUE_APP_URL_API}/`,
    headers: {Accept: 'application/json'},
})
axiosIns.showLoader = true
let requestsPending = 0
const req = {
    pending: () => {
        // eslint-disable-next-line no-plusplus
        requestsPending++

        if (axiosIns.showLoader) {
            store.dispatch(`${actionScope}/show`)
        }
    },
    done: () => {
        // eslint-disable-next-line no-plusplus
        requestsPending--
        if (requestsPending <= 0) {
            if (axiosIns.showLoader) {
                store.dispatch(`${actionScope}/hide`)
            }
        }
    },
}

axiosIns.interceptors.request.use(
    request => {
        const authToken = localStorage.getItem('accessToken')
        if (authToken) {
            request.headers.Authorization = `Bearer ${authToken}`
        }
        const showLoading = request.loading === undefined ? true : request.loading
        if (showLoading) {
            req.pending()
        }
        return request
    },
    error => {
        // eslint-disable-next-line no-plusplus
        requestsPending--
        req.done()
        Promise.reject(error)
    },
)
axiosIns.interceptors.response.use(
    response => {
        req.done()
        if (response.status >= 200 && response.status < 300) {
            if (response.headers['content-disposition'] && response.headers['content-disposition'].indexOf('attachment') > -1) {
                return response
            }
            if (response.headers['content-type'] !== 'application/json') {
                return response.data
            }

            if (response.data.meta || response.data.error) {
                return response.data
            }
            if (response.data && Object.prototype.hasOwnProperty.call(response.data, 'data')) {
                return response.data.data
            }
            return response ? response.data : false
        }
        return false
    },
    error => {
        req.done()
        if (!error.response) {
            return {
                api_status: 0,
                api_statusText: 'response error',
                data: [],
            }
        }

        const {status, data, statusText} = error.response

        // ===== 401 Reautenticação com modal, preservando a tela atual =====
        if (status === 401) {
            const cfg = error.config || {}

            // Evita loops (não atuar em rotas de auth e nem repetir)
            const url = (cfg && cfg.url) ? String(cfg.url) : ''
            const isAuthRoute = /(login|perdi-minha-senha|recuperar-senha|oauth\/token|auth\/)/.test(url)
            const isLoginPath = (
                window.location.pathname.startsWith('/login')
                || window.location.pathname.startsWith('/perdi-minha-senha')
                || window.location.pathname.startsWith('/recuperar-senha')
                || window.location.pathname.startsWith('/pdv')
            )
            if (cfg.__isRetry || isAuthRoute) {
                return {
                    error: status,
                    api_statusText: statusText,
                    error_message: data?.error_message || data?.message,
                    errors: data?.errors,
                    data: data?.data,
                }
            }

            // Se já está na página de login, mantém comportamento atual
            if (isLoginPath) {
                return {
                    error: status,
                    api_statusText: statusText,
                    error_message: data?.error_message || data?.message,
                    errors: data?.errors,
                    data: data?.data,
                }
            }

            // Singleton de reauth em progresso via Vuex (abre modal)
            if (!window.__reauthPromise) {
                window.__reauthPromise = store.dispatch('authUi/openLoginModal')
                    .finally(() => { window.__reauthPromise = null })
            }

            // Enfileira a requisição atual e reexecuta após sucesso
            return window.__reauthPromise.then(() => {
                // Reexecuta com novo token
                const token = localStorage.getItem('accessToken')
                const newCfg = { ...cfg, __isRetry: true }
                if (!newCfg.headers) newCfg.headers = {}
                if (token) newCfg.headers.Authorization = `Bearer ${token}`
                return axiosIns(newCfg)
            }).catch(() => {
                // Usuário cancelou: fallback para página de login com next
                try {
                    const next = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash)
                    localStorage.clear()
                    window.location.href = `/login?next=${next}`
                } catch (e) {
                    localStorage.clear()
                    window.location.href = '/login'
                }
                return {
                    error: status,
                    api_statusText: statusText,
                    error_message: 'Não autenticado',
                    errors: data?.errors,
                    data: data?.data,
                }
            })
        }


        return {
            error: status,
            api_statusText: statusText,
            error_message: data.error_message || data.message,
            errors: data.errors,
            data: data.data,
        }
    },
)
Vue.prototype.$http = axiosIns
window.http = axiosIns
window.$http = axiosIns
export default axiosIns
